import React, {FC} from 'react';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {AccountDetailsPanelId} from '../../store/panels/panelStateBase';
import {AccountDetailsContainer} from '../accounts/accountDetails/accountDetailsContainer';
import {Frame} from '../common/frames/frame';

interface PopupAccountDetailsComponentProps {
  panelId: AccountDetailsPanelId;
  onRequestClose: Handler;
  accountId: number | undefined;
  popupWidth?: number;
  popupConversationId?: number;
}

/*
 * Component.
 */

export const PopupAccountDetails: FC<PopupAccountDetailsComponentProps> = (props) => {
  const {panelId, popupWidth, accountId, onRequestClose} = props;
  // If we do not have an account, close the window.
  if (!accountId) {
    onRequestClose();
    return null;
  }

  return (
    <Frame
      minWidth="270px"
      width={popupWidth ?? 300}
      height={700}
      shouldForcePopout
      onRequestClose={onRequestClose}
      startHeight={undefined}
      interactionId="popup-account-details"
    >
      <AccountDetailsContainer panelId={panelId} accountId={accountId} />
    </Frame>
  );
};
